export class Entrada {
    Id: number;
    Nombre: string;
    Precio: string;
  }
  